<template>
  <div class="booking-travel">
    <img class="top-info" src="../../assets/booking_banner/reason.jpg" alt="">
    <div class="screen-box" v-show="!hasBindTicket">
      <div class="screen-item" @click="countryChooseShow = true">
        <span>{{countryNames[countryActive] ? countryNames[countryActive].name : ''}}</span>
        <img class="icon-arrow-down" src="../../assets/icons/icon_arrow_down.png" alt="">
      </div>
      <div class="screen-item" @click="cityChooseShow = true">
        <span>{{cityNames[cityActive] ? cityNames[cityActive].name : ''}}</span>
        <img class="icon-arrow-down" src="../../assets/icons/icon_arrow_down.png" alt="">
      </div>
    </div>
    <div class="product-list" v-if="productList.length">
      <template v-if="!hasBindTicket">
        <div v-for="item in productList" :key="item.shorexId">
          <div class="label"><span>{{item.shorexTypeName}}</span></div>
          <div class="product-item" v-for="productItem in item.list" :key="productItem.introPartId">
            <van-image class="item-img" :src="productItem.banner[0]" />
            <div class="product-info">
              <div class="info-main">
                <div class="name-line">
                  <div class="name-box">
                    <p>{{productItem.shorexName}}</p>
                    <img class="label-title" v-if="productItem.shorexTagShow && productItem.shorexTagShow.imageUe" :src="productItem.shorexTagShow.imageUe" :alt="productItem.shorexTagShow.tagName" />
                  </div>
                  <a href="javascript:;" class="btn-order" @click="checkLoginStatus">绑定船票</a>
                </div>
                <p class="product-desc">{{productItem.shorexBrief}}</p>
                <div class="product-params">
                  <div class="item">
                    <img class="icon-dollar" src="../../assets/icons/icon_dollar.png" alt="">
                    价格：<span>{{productItem.shorexPrice}}</span>美金/人
                  </div>
                  <div class="item">
                    <img class="icon-clock" src="../../assets/icons/icon_clock2.png" alt="">
                    时长：<span>{{productItem.duration}}</span>
                  </div>
                </div>
              </div>
              <p class="desc-detail">{{productItem.shorexDescription}}</p>
            </div>
            <div class="recommend" v-if="productItem.cruisePartAndIntroPardModels && productItem.cruisePartAndIntroPardModels.length">
              <div class="recommend-title">
                <img class="icon" src="../../assets/icons/icon_ship2.png" alt="">
                近期航次推荐
              </div>
              <div class="route-list">
                <a href="javascript:;" class="route-item" v-for="modelItem in productItem.cruisePartAndIntroPardModels" :key="modelItem.shipCode">{{handleShip(modelItem.shipCode)}}{{handleSailDate(modelItem.sailDate)}}</a>
              </div>
            </div>
          </div>
        </div>
      </template>
      <sightseeing-card v-else :cardData="productList" @checkval = "checkval" :isTravelPage="true" :checkId="selectedShorex"/>
      <div class="tips">
        <p class="title"><span>注：</span></p>
        <p class="tips-item"><span>（1）</span>请以关联船票后选择的行程及其价格为准。</p>
        <p class="tips-item"><span>（2）</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</p>
        <p class="tips-item"><span>（3）</span>目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</p>
        <p class="tips-item"><span>（4）</span>本站以外预订，请以相关渠道信息为准。</p>
      </div>
    </div>
    <no-data v-else type="2" />
    <!-- 选择国家 -->
    <custom-picker title="选择国家" :columns="countryNames" :visible.sync="countryChooseShow" @change="countryChange" />
    <!-- 选择城市 -->
    <custom-picker title="选择城市" :columns="cityNames" :visible.sync="cityChooseShow" @change="cityChange" />
  </div>
</template>

<script>
import api from '@/api'
import { shorexTypes, shipList } from '@/utils/dict'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import CustomPicker from '@/components/CustomPicker'
import NoData from '@/components/NoData'
import SightseeingCard from '../shopping_cart/SightseeingCard'
import dayjs from 'dayjs'
import { checkLoginStatus, getShoppingCartNum } from '@/plugins/common'

export default {
  name: 'BookingTravel',

  components: {
    CustomPicker,
    SightseeingCard,
    NoData
  },

  data () {
    return {
      checkLoginStatus,
      productList: [],
      countrys: [],
      countryChooseShow: false,
      countryActive: 0,
      cityChooseShow: false,
      cityActive: 0,
      selectedShorex: null
    }
  },

  watch: {
    type: {
      handler () {
        this.productList = []
        this.getProductShorex('')
      },
      immediate: true
    }
  },

  computed: {
    hasBindTicket () {
      return Boolean(this.$store.state.bindTicket)
    },
    countryNames () {
      return this.countrys.length ? this.countrys.map((x, i) => ({ name: x.name, value: i })) : []
    },
    cityNames () {
      return this.countrys.length ? this.countrys[this.countryActive].cityPort.map((x, i) => ({ name: x.cityName, value: i })) : []
    }
  },

  methods: {
    cityChange (index) {
      if (index === this.cityActive) return
      this.cityActive = index
      this.getProductShorex(this.cityNames[index].name)
    },
    countryChange (index) {
      if (index === this.countryActive) return
      this.countryActive = index
      this.cityActive = 0
      this.getProductShorex(this.cityNames[0].name)
    },
    async getProductShorex (cityName) {
      showLoading()
      const { errCode, errMsg, data } = await api.getProductShorex(cityName)
      hideLoading()
      if (errCode === 0) {
        if (this.hasBindTicket) {
          this.productList = data.shorex.shorexViewModels.filter(arr => arr.shorexType !== 1)
          this.selectedShorex = data.selectedShorex
        } else {
          const { shorexIntros, countrys } = data
          this.productList = []
          if (shorexIntros && shorexIntros.length) {
            for (let i = 0; i < shorexTypes.length; i++) {
              const list = shorexIntros.filter(x => x.shorexType === shorexTypes[i].value)
              if (list.length) {
                this.productList.push({
                  shorexType: shorexTypes[i].value,
                  shorexTypeName: shorexTypes[i].name,
                  list
                })
              }
            }
          }
          this.countrys = countrys || []
        }
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    handleShip (value) {
      const matching = shipList.find(x => x.value === value)
      return matching ? matching.name : ''
    },
    handleSailDate (date) {
      return dayjs(date).format('MM月DD日')
    },
    checkval () {
      this.getProductShorex('')
      getShoppingCartNum()
    }
    // 获取购物车数据
    // async getShoppingCartNumber () {
    //   showLoading()
    //   const { errCode, errMsg, data } = await api.getShoppingCartsList()
    //   let cartNumber = 0
    //   hideLoading()
    //   if (errCode === 0) {
    //     if (data.shorexPartViews !== null) {
    //       cartNumber = data.shopCartItems.length
    //       this.allBookingGuests = data.allBookingGuests
    //       if (data.selectedShorex !== 0) {
    //         cartNumber++
    //       }
    //       this.$store.commit('store', {
    //         goodsCartNum: cartNumber
    //       })
    //     } else {
    //       this.$store.commit('store', {
    //         goodsCartNum: 0
    //       })
    //     }
    //   } else {
    //     showAlert(errMsg)
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
.top-info {
  display: block;
  width: 100%;
}
.screen-box {
  height: 110px;
  display: flex;
  background-color: #fff;
  .screen-item {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: @main-color;
    .icon-arrow-down {
      width: 21px;
      margin-left: 15px;
    }
    &:first-child {
      border-right: 1Px solid @main-gray5;
    }
  }
}
.product-list {
  padding: 0 50px;
  ::v-deep .sightseeing-card {
    background-color: #fff;
    margin-top: 40px;
    padding-top: 25px;
  }
  .label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 106px;
    span {
      height: 46px;
      padding: 0 35px;
      border-radius: 23px;
      font-size: 30px;
      color: 666;
      line-height: 46px;
      background-color: #e5e5e5;
    }
  }
  .product-item {
    margin-bottom: 30px;
    background-color: #fff;
    .item-img {
      display: block;
      height: 400px;
    }
  }
  .product-info {
    padding: 0 30px;
    .info-main {
      padding: 15px 0 20px;
      border-bottom: 1Px solid #eaeaea;
      .name-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 58px;
        .name-box {
          display: flex;
          align-items: center;
          font-size: 30px;
          color: @main-color;
          .label-title {
            flex: none;
            width: 90px;
            height: 30px;
            margin-left: 12px;
          }
        }
        .btn-order {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 155px;
          height: 46px;
          border-radius: 6px;
          font-size: 18px;
          color: #333;
          .btn-linear-gradient;
        }
      }
      .product-desc {
        margin-top: 11px;
        font-size: 24px;
        color: 666;
        line-height: 34px;
      }
      .product-params {
        display: flex;
        align-items: center;
        height: 42px;
        margin-top: 6px;
        font-size: 24px;
        color: #1174b8;
        .item {
          display: flex;
          align-items: center;
          margin-right: 46px;
          .icon-dollar {
            width: 15px;
            margin-right: 8px;
          }
          .icon-clock {
            width: 23px;
            margin-right: 8px;
          }
          span {
            color: @second-color;
          }
        }
      }
    }
    .desc-detail {
      padding: 22px 0;
      font-size: 24px;
      color: #999;
      line-height: 38px;
    }
  }
  .recommend {
    padding: 10px 30px 42px;
    background-color: #eaeaea;
    .recommend-title {
      display: flex;
      align-items: center;
      height: 90px;
      font-size: 30px;
      color: #333;
      .icon {
        width: 46px;
        margin-right: 22px;
      }
    }
    .route-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .route-item {
        width: 290px;
        height: 46px;
        margin-bottom: 10px;
        border-radius: 23px;
        text-align: center;
        font-size: 24px;
        color: #4890c1;
        line-height: 46px;
        background-color: #e8f4fe;
      }
    }
  }
}
.tips {
  padding: 30px 0 18px;
  font-size: 24px;
  color: #999;
  line-height: 38px;
  .title {
    margin-bottom: 3px;
    color: #333;
    span {
      color: @error-color;
    }
  }
  .tips-item {
    display: flex;
    margin-left: -14px;
  }
}
</style>
